import * as types from './types';

const initialState = {
  YusaOvernightCampAssociationList: {},
  YusaOvernightCampYearList: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.OVERNIGHT_CAMP_ASSOCIATION_LIST_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampAssociationList: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_ASSOCIATION_LIST_FAILURE:
      return { ...state, error: action.payload };

    case types.OVERNIGHT_CAMP_YEAR_LIST_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampYearList: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_YEAR_LIST_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
